import Vue from 'vue'
// 动态注册全局组件
const conmponentsContext = require.context('@/modules', true, /.vue$/)
conmponentsContext.keys().forEach(component => {
  const componentConfig = conmponentsContext(component).default
  Vue.component(componentConfig.name, componentConfig)
})



// WEBPACK FOOTER //
// ./src/common/common.js